import styled from '@emotion/styled';
import { TabContext } from '@mui/lab';
import {
  Box,
  Tabs,
  Tab,
  Grid,
  TextField,
  InputAdornment,
  Typography,
  Button,
  TableRow,
  TableCell,
  Autocomplete
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';
import SearchIcon from '@mui/icons-material/Search';
import Table from '../../../components/Table';
import { Company } from '../../../schema/company';
import { TableResponse } from '../../../schema/helper';
import { BlacklistCompany } from '../../../schema/blacklist';
import { api } from '../../../api';

const tableHead = [
  'รหัสบริษัท',
  'ชื่อบริษัท',
  'วันที่ลงประวัติ Blacklist',
  'วันที่สิ้นสุด Blacklist',
  'สถานะ',
  'Actions'
];

const TableCompanyBlacklist = () => {
  const today = new Date();
  const [filterCode, setFilterCode] = useState<string>('');
  const [filterName, setFilterName] = useState<string>('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState<TableResponse<BlacklistCompany> | null>(null);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const handleExportCSVFile = () => {
    if(isExportLoading){
      return
    }
    const searchParams = new URLSearchParams();
    if (filterCode) {
      searchParams.set('company_code', filterCode);
    }
    if (filterName) {
      searchParams.set('company_name', filterName);
    }
    setIsExportLoading(true)
    api
      .get(`/blacklist_company/export`, {
        params: searchParams,
        responseType: 'blob'
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'blacklist_company_export_data.xlsx');
        document.body.appendChild(link);
        link.click();
      }).finally(()=>setIsExportLoading(false))
  };

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const searchParams = new URLSearchParams();
      if (filterCode) {
        searchParams.set('company_code', filterCode);
      }
      if (filterName) {
        searchParams.set('company_name', filterName);
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);

      api
        .get<TableResponse<BlacklistCompany>>(`/blacklist_company/table`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setData(data);
        });
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [filterCode, filterName, page, rowsPerPage]);

  return (
    <>
      <Grid container spacing={2} marginTop={1}>
        <Grid item md={3}>
          <TextField
            label="ค้นหารหัสบริษัท"
            variant="outlined"
            placeholder="ค้นหารหัสบริษัท"
            onChange={(event) => setFilterCode(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="ค้นหาชื่อบริษัท"
            variant="outlined"
            placeholder="ค้นหาชื่อบริษัท"
            onChange={(event) => setFilterName(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>

        <Grid item md sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            component={Link}
            to={`/blacklist/create`}
            variant="contained"
            color="primary"
            sx={{ marginRight: 1 }}
          >
            เพิ่มข้อมูล
          </Button>
          <Button variant="outlined" color="primary" onClick={handleExportCSVFile} disabled={isExportLoading}>
            Export
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ padding: '24px 0' }}>
        <Table
          heads={tableHead}
          count={data?.total ? data?.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {data?.data.map((data, index) => {
            let blacklist_active = true;
            const start = new Date(data.blacklist_start_date);

            if (start >= today) {
              blacklist_active = true;
            }

            if (data.blacklist_end_date) {
              const end = new Date(data.blacklist_end_date);
              if (end < today) {
                blacklist_active = false;
              }
            }

            return (
              <TableRow key={index}>
                <TableCell align="center">{data.company.company_code}</TableCell>
                <TableCell align="center">{data.company.company_name}</TableCell>
                <TableCell align="center">{data.blacklist_start_date}</TableCell>
                <TableCell align="center">
                  {data.blacklist_end_date ? data.blacklist_end_date : '-'}
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" color={blacklist_active ? 'success.main' : 'error'}>
                    {blacklist_active ? 'Active' : 'Inactive'}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  {/* <Button variant="contained" color="success" sx={{ marginX: 0.5 }}>
                    ข้อมูล
                  </Button> */}
                  <Button
                    component={Link}
                    to={`/blacklist_company/${data.company_id}/edit`}
                    variant="contained"
                    color="warning"
                    sx={{ marginX: 0.5 }}
                  >
                    แก้ไข
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </Table>
      </Box>
    </>
  );
};

export default TableCompanyBlacklist;
